export default function UuDaiHangHang() {
    return (
        <div className="">
            <div className="">
                <div className="MuiContainer-root styles_boxContainer__t2s4X MuiContainer-maxWidthLg">

                    {/* Title */}
                    <div className="styles_companyIntroduction__h04I7">
                        <div className="styles_title__JlrYL">
                            <div className="styles_companyTitle__W3WKs styles_companyIntroductionForU__tkUSt">
                                Nhận ngay ưu đãi dành cho bạn!{" "}
                                <span className="styles_branchName__QPk2S"></span>
                            </div>
                        </div>
                    </div>

                    {/* Blocks */}
                    <div className="styles_box__n8VEY">

                        {/* Block 1 - Vận chuyển */}
                        <div className="styles_blockWrapper__BHPXM">
                            <div className="styles_block__0THo_">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: 40,
                                        height: 40,
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        position: "relative",
                                    }}
                                >
                                    <img
                                        alt="ICON"
                                        src="https://cdn-web-next.thuocsi.vn/images/home/iconCar.svg"
                                        decoding="async"
                                        loading="lazy"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>
                                <p className="styles_text__iDlub">
                                    Giảm 10% &amp; miễn phí vận chuyển cho đơn hàng đầu tiên.
                                </p>
                            </div>
                        </div>

                        {/* Block 2 - Voucher */}
                        <div className="styles_blockWrapper__BHPXM">
                            <div className="styles_block__0THo_">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: 40,
                                        height: 40,
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        position: "relative",
                                    }}
                                >
                                    <img
                                        alt="ICON"
                                        src="https://cdn-web-next.thuocsi.vn/images/home/iconVoucher.svg"
                                        decoding="async"
                                        loading="lazy"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>
                                <p className="styles_text__iDlub">
                                    Tham gia chương trình trả thưởng nhận ngay voucher.
                                </p>
                            </div>
                        </div>

                        {/* Block 3 - Đăng ký */}
                        <div className="styles_blockWrapper__BHPXM">
                            <button
                                className="MuiButtonBase-root MuiButton-root MuiButton-text styles_block__0THo_ styles_bgKey__uVDUt"
                                tabIndex={0}
                                type="button"
                            >
                                <span className="MuiButton-label">
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "inline-block",
                                            overflow: "hidden",
                                            width: 40,
                                            height: 40,
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: "0px",
                                            padding: "0px",
                                            position: "relative",
                                        }}
                                    >
                                        <img
                                            alt="ICON"
                                            src="https://cdn-web-next.thuocsi.vn/images/home/iconKey.svg"
                                            decoding="async"
                                            loading="lazy"
                                            style={{
                                                position: "absolute",
                                                inset: "0px",
                                                boxSizing: "border-box",
                                                padding: "0px",
                                                border: "none",
                                                margin: "auto",
                                                display: "block",
                                                width: "0px",
                                                height: "0px",
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                                minHeight: "100%",
                                                maxHeight: "100%",
                                            }}
                                        />
                                    </span>
                                    <p className="styles_text__iDlub">
                                        Đăng ký ngay để nhận ưu đãi!
                                    </p>
                                </span>
                                <span className="MuiTouchRipple-root"></span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}